import React from "react";
import { View, Text, StyleSheet } from "../platformComponents";
import { IS_WEB, tranformPx } from "@adgm/libs";

interface OpportunityOverviewProps {
  title: string;
  text: string;
}

export const OpportunityOverview: React.FC<OpportunityOverviewProps> = ({ title, text }) => (
  <View style={styles.container}>
    <Text style={styles.title}>{title}</Text>
    <View style={styles.card}>
      <Text style={styles.text}>{text}</Text>
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: "100%",
    ...(IS_WEB && {
      height: "100%",
      display: "flex",
      flexDirection: "column",
    }),
  },
  title: {
    fontWeight: "700",
    marginBottom: tranformPx(16),
    ...(IS_WEB
      ? {
          fontSize: 22,
          color: "rgba(255, 255, 255, 0.8)",
        }
      : { fontSize: tranformPx(18), color: "#fff" }),
  },
  card: {
    flex: 1,
    borderRadius: 16,
    borderWidth: 1,
    ...(IS_WEB
      ? {
          padding: 32,
          borderColor: "#3F434F",
        }
      : {
          padding: 16,
          borderColor: "#303030",
        }),
  },
  text: {
    lineHeight: 30,
    color: "rgba(255, 255, 255, 0.75)",
    textAlign: IS_WEB ? "justify" : "left",
    ...(!IS_WEB && { fontSize: tranformPx(14) }),
  },
});
